import React from 'react';
import img from "../../assets/head_phone.png"

const HeadPhone = ({}) => {
    return (
        <div className="relative bg-green-900/20 rounded-full p-6">
            <div className="relative bg-green-900/20 rounded-full p-6">
                <img src={img} alt=""/>
            </div>
        </div>
    )
}

export default HeadPhone